import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-black border-y border-dark-border" data-id="element-117" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-118" data-mp="223oe5gim9ucu">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-dark-card border border-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-119" data-mp="222n0r5e4ovry">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold-gradient" data-id="element-120" data-mp="14gz2eey443ds" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gold/10 text-gold mb-8" data-id="element-121" data-mp="1j5c31p85aaem">
            <ShieldCheck size={48} data-id="element-122" data-mp="1ecj096w8lc56" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-123" data-mp="qnq2d4w20u7x">🛡️ Garantie satisfait ou remboursé — 7 jours complets</h2>
          <div className="space-y-6 text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-124" data-mp="lon5i7q89ub1">
            <p data-id="element-125" data-mp="oygmkhm5dibv">
              Ouvre tout le système pédagogique. Explore les 5 bonus. Utilise le matériel pour ton cours le plus difficile cette
              semaine.
            </p>
            <p className="font-medium text-white" data-id="element-126" data-mp="yot6c7m517gy">
              Si tu considères que le matériel n&apos;est pas clair, pratique ou utile pour tes besoins d&apos;enseignement —
              contacte-nous dans les 7 jours.
            </p>
            <p className="text-gold-light font-bold text-xl" data-id="element-127" data-mp="628e74xu8rcc">
              Tu seras intégralement remboursé. Sans questions. Sans formulaire. Sans complications.
            </p>
            <p className="text-sm text-gray-400 mt-8" data-id="element-128" data-mp="f0aj3vkp044w">
              Parce que si le matériel ne tient pas la promesse de valeur que nous faisons, nous ne voulons pas garder ton argent.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}